import React from "react";
import { Typography, Button, Box, alpha, useTheme } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";

interface CompleteStepProps {
  onCreateNew: () => void;
}

const CompleteStep: React.FC<CompleteStepProps> = ({ onCreateNew }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 6,
        gap: 3,
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 64, color: "success.main" }} />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
          Signed Off
        </Typography>
        <Typography variant="body2" color="text.secondary">
          The template has been reviewed and signed off successfully.
        </Typography>
      </Box>
      <Button
        variant="outlined"
        sx={{
          textTransform: "none",
          borderRadius: 2,
          px: 4,
          py: 1.25,
          fontWeight: 600,
          transition: "all 0.2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            borderColor: "primary.main",
          },
        }}
        onClick={onCreateNew}
      >
        Create New Template
      </Button>
    </Box>
  );
};

export default CompleteStep;
